import axios from 'axios';

export function postRequestTc(tcRequest) {
    return axios({
        method: 'POST',
        url: '/api/v2/timecharters/orders/create-from-admin',
        withCredentials: true,
        data: tcRequest,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function deleteTcRequest(tcRequestId) {
    return axios({
        method: 'delete',
        url: `/api/v2/timecharters/orders/admin/${tcRequestId}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getRequestsTc(filter) {
    return axios({
        method: 'post',
        url: '/api/v2/timecharters/orders/admin/tc',
        withCredentials: true,
        data: {
            ...filter
        },
    })
        .then(response => response.data)
        .catch(response => response.data);
}



// WEBPACK FOOTER //
// ./app/services/tc/requests.js